import { Reducer } from 'redux'
import { LOGIN, TYPES } from './types'
import { AnyAction } from 'models/types'

const INITIAL_STATE: LOGIN = {
  login: {
    email: '',
    senha: '',
    lembrar: false
  },
  recuperacao: {
    senha: '',
    confirmacaoSenha: ''
  },
  loading: false,
  loadingPermissoes: false,
  allowedRoutes: [],
  allowedActions: {
    atendimento: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    tabulacao: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    producao: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    produto: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    inicio: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    historico: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    carteira: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    grupos: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    blacklist: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    uploadArquivos: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    agenda: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    credenciais: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    indicadores: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    campanha: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    indicacao: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    cadastroModelo: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    kanban: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    },
    configuracaoKanban: {
      gravar: false,
      estornar: false,
      visualizar: false,
      autorizar: false,
      exportar: false,
      deletar: false,
      iniciarPausar: false,
      iniciarCampanhaCrm: false
    }
  },
  webSockets: {
    notificacaoInitialized: false,
    retornoDiscagemTelecomInitialized: false,
    discadorInitialized: false
  },
  atendimentoAtivoVerificado: false,
  parametrosValidos: false,
  parametrosValidosVerificados: false
}

const reducer: Reducer<LOGIN, AnyAction> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.SET_LOGIN:
      return {
        ...state,
        login: { ...state.login, [action.field]: action.value }
      }
    case TYPES.CLEAN_LOGIN:
      return {
        ...state,
        login: INITIAL_STATE.login
      }
    case TYPES.SET_LOADING:
      return {
        ...state,
        loading: action.value
      }
    case TYPES.SET_RECUPERACAO:
      return {
        ...state,
        recuperacao: { ...state.recuperacao, [action.field]: action.value }
      }
    case TYPES.SET_PERMISSOES_USUARIO:
      return {
        ...state,
        allowedRoutes: action.value
      }
    case TYPES.SET_LOADING_PERMISSOES:
      return {
        ...state,
        loadingPermissoes: action.value
      }
    case TYPES.CLEAN_PERMISSOES_USUARIO:
      return {
        ...state,
        allowedRoutes: INITIAL_STATE.allowedRoutes
      }
    case TYPES.SET_PERMISSOES_ACTIONS_USUARIO:
      return {
        ...state,
        allowedActions: {
          ...state.allowedActions,
          ...action.value
        }
      }
    case TYPES.CLEAN_PERMISSOES_ACTIONS_USUARIO:
      return {
        ...state,
        allowedActions: INITIAL_STATE.allowedActions
      }
    case TYPES.SET_STATUS_WEBSOCKTES:
      return {
        ...state,
        webSockets: {
          ...state.webSockets,
          [action.field]: action.value
        }
      }
    case TYPES.SET_ATENDIMENTO_ATIVO_VERIFICADO:
      return {
        ...state,
        atendimentoAtivoVerificado: action.value
      }
    case TYPES.SET_PARAMETROS_VALIDOS:
      return {
        ...state,
        parametrosValidos: action.value
      }
    case TYPES.SET_PARAMETROS_VALIDOS_VERIFICADO:
      return {
        ...state,
        parametrosValidosVerificados: action.value
      }
    default:
      return state
  }
}

export default reducer
